(function () {
  function bindHoverVideo(mediaRoot) {
    if (mediaRoot.dataset.buffCardVideoBound === 'true') return;
    const card = mediaRoot.closest('.card--product');
    const video = mediaRoot.querySelector('video');
    if (!card || !video) return;

    mediaRoot.dataset.buffCardVideoBound = 'true';
    video.pause();
    video.currentTime = 0;

    const playBtn = card.querySelector('[data-buff-card-play]');

    const setPlayingUI = (isPlaying) => {
      card.classList.toggle('is-playing', isPlaying);
      if (!playBtn) return;
      playBtn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      playBtn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      const playIcon = playBtn.querySelector('.buff-card-play-btn__icon--play');
      const pauseIcon = playBtn.querySelector('.buff-card-play-btn__icon--pause');
      if (playIcon) playIcon.hidden = isPlaying;
      if (pauseIcon) pauseIcon.hidden = !isPlaying;
    };

    const playVideo = () => {
      video.play().catch(() => {});
      setPlayingUI(true);
    };

    const pauseVideo = () => {
      video.pause();
      video.currentTime = 0;
      setPlayingUI(false);
    };

    const togglePlay = (event) => {
      // Stop the parent product link from navigating
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      if (card.classList.contains('is-playing') && !video.paused) {
        pauseVideo();
      } else {
        playVideo();
      }
    };

    // Desktop/hover devices: play on hover/focus. Skip on touch so focus+click don't fight.
    if (window.matchMedia('(hover: hover)').matches) {
      card.addEventListener('mouseenter', playVideo);
      card.addEventListener('mouseleave', pauseVideo);
      card.addEventListener('focusin', playVideo);
      card.addEventListener('focusout', pauseVideo);
    }

    if (playBtn) {
      // pointerdown handles play/pause before the parent <a> navigates
      playBtn.addEventListener('pointerdown', togglePlay);
      // Suppress the follow-up click so we don't toggle twice or follow the link
      playBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
      });
      playBtn.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          togglePlay(event);
        }
      });
    }
  }

  function initBuffCardHoverVideo(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-buff-card-hover-video]').forEach(bindHoverVideo);
  }

  // Expose for async-injected cards (e.g. product recommendations section)
  window.initBuffCardHoverVideo = initBuffCardHoverVideo;

  document.addEventListener('DOMContentLoaded', function () {
    initBuffCardHoverVideo();
  });
  document.addEventListener('shopify:section:load', function (event) {
    initBuffCardHoverVideo(event.target);
  });

  // Catch cards injected after initial load (product recommendations fetch, etc.)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('[data-buff-card-hover-video]')) {
            bindHoverVideo(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('[data-buff-card-hover-video]').forEach(bindHoverVideo);
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
